import styled from "styled-components";

export const CustomLink = styled.div`
  color: ${({ theme }) => theme.pallette.blue.link};
  display: inline;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;
